import api from '../services/api';

const BASE_URL = process.env.REACT_APP_FAST_FOOD_SERVICE || '';

// La tasa del servidor es la oficial; localStorage queda como copia para leerla sin esperar.
export const syncExchangeRate = async () => {
    try {
        const { data } = await api.get('/api/pos/exchange-rate/', { baseURL: BASE_URL });
        if (data?.rate > 0) {
            localStorage.setItem('usdExchangeRate', String(data.rate));
            return data.rate;
        }
    } catch (err) {
        console.warn('No se pudo actualizar la tasa de cambio:', err.message);
    }
    return null;
};

export const saveExchangeRate = async (rate) => {
    const { data } = await api.post('/api/pos/exchange-rate/', { rate }, { baseURL: BASE_URL });
    localStorage.setItem('usdExchangeRate', String(data.rate));
    return data.rate;
};
